import React, { Component, Fragment, useEffect } from 'react';
import { Navigationmenu } from '../components';
import { Page404 } from '../components/Page404';
import CircularProgress from '@material-ui/core/CircularProgress'
import ReactSession from '../reactclient.js';
import { withRouter } from 'react-router-dom';
import circulargridimage from '../gallery/gridloader.gif';

import { fnPostapiResponse, fnGETapiResponse, Fnencryption, fntoConvertdexceldate } from '../APICall';
import DatePicker from 'react-datepicker';
import moment, { max } from 'moment';
// import 'react-datepicker/dist/react-datepicker.css';
import Footer from '../components/Footer';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import { OutTable, ExcelRenderer } from 'react-excel-renderer';



import {
    Box,
    Button,
    Typography,
    Grid,
    TextField,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    FormControl,
    Divider,
    Select,
    InputLabel,
    MenuItem,
    Popover,
    Dialog,
    Tabs,
    Tab,
    DialogActions,
    withStyles, Checkbox,
    TableFooter, Container, Accordion, AccordionSummary,
    AccordionDetails
} from '@material-ui/core';
import Autocomplete from '@mui/material/Autocomplete';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { FileCopy, Refresh, Add, Delete, Edit, ColorLensOutlined, RepeatOneSharp } from '@material-ui/icons';
import { ExportExcel } from './ExportExcel';

import {
    SearchOutlined,
    ArrowDropDown,
    Publish,
    NoteAdd,
    ArrowDropUp,
    InsertDriveFileOutlined,
    QueryBuilderTwoTone
} from '@material-ui/icons';
import {
    ALTERNATEROW_BACKGROUND_COLOR,
    BLUE_COLOR, LIGHTGRAY_COLOR,
    MODIFIEDBLACK,
    PINK_COLOR,
    PROTECT_GREEN,
    RED_COLOR,
    VIBRANT_GREEN, DARKGREEN_COLOR,
    LIGHTGREEN_COLOR
} from "../constants";
import Switch from '@material-ui/core/Switch';
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import List from "@material-ui/core/List";
import renderIf from 'render-if';
import { Redirect } from "react-router-dom";
import * as FileSaver from 'file-saver';
import * as XLSX from 'sheetjs-master';
import axios from "axios"
import { IdleTimeOutModal } from '../components/Logoutmodal';
import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import { useRef } from "react";
import { style } from '@mui/system';
import CircularProgressWithLabel from '../components/CircularProgressWithLabel'
const StyledTabs = withStyles({
    indicator: {
        display: 'flex',
        backgroundColor: 'white',
        height: 3
    },
}, { index: 1 })((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);
const SomeComponent = withRouter(props => <BatchPage {...props} />);
const StyledTab = withStyles((theme) => ({
    root: {
        textTransform: 'none',
        color: 'white',
        fontWeight: theme.typography.fontWeightRegular,
        fontSize: theme.typography.pxToRem(15),
        '&:focus': {
            opacity: 1
        }
    },
}, { index: 1 }))((props) => <Tab disableRipple {...props} />);
export default class BatchPage extends Component {
    state = {
        DBUserName: "",
        DBPassword: "",
        DBSource: "",
        DBProvider: "",
        test: false,
        isloading: "none",
        isloading1: false,
        selectedUser: "",
        selectedPass: "",
        AllBatchId: "",
        batchId: "",
        lablebatchId: "",
        modalmessage: "",
        showModal: false,
        rows: [],
        cols: [], columnsrow: [],
        txtBatchname: "",
        disablebutton: false,
        disablebuttoncolor: BLUE_COLOR,
        viewErrorpage: false,
        batchesarray: [],
        SearchOptions: [],
        SearchOptions1: [{ BATCHID: 'SGL2022080903-00120220809134610543272', BATCHCOUNT: 5, BATCHCOLOR: 'red' },
        { BATCHID: 'SGL2022080902-00120220809134158174396', BATCHCOUNT: 5, BATCHCOLOR: 'green' },
        { BATCHID: 'SGL2022080901-00120220809093935875390', BATCHCOUNT: 5, BATCHCOLOR: 'yellow' },
        { BATCHID: 'SLL2022080901-001', BATCHCOUNT: 6, BATCHCOLOR: 'blue' }],
        SearchOptions2: ['SGL2022080903-00120220809134610543272', 'SGL2022080903-00120220809134610543273', 'SGL2022080903-00120220809134610543274'
            , 'SGL2022080903-00120220809134610543275'],
        SelectedCompany: "",
        selectedsearchtype: "FULL-ONGOING",
        displayloader: 'none',
        tablebuffer: [
        ],
        isTemptableBuffer: [],
        pagesObj: [],
        pages: 0,
        CompanyType: [],
        current: 1,
        records: 0,
        pageSize: 10,
        showPager: false,
        selectedClientID: "",
        txtSelectedRowSurname: "",
        txtSelectedRowFirstname: '',
        txtSelectedRowNIC: "",
        txtSelectedRowDOB: "",
        chkboxIsverify: false,
        errorRowColumnVisible: 'none',
        alldata: [],
        todayDate: "",
        AllBatchIdCount: 0,
        AllBatchIdWidthOutComma: '',
        ddRowGender: 'U',
        runbatchIdvalue: 0,
        showfirstloader: false,
        showsecondLoader: false,
        errormessageisenabled: false
    }

    componentDidMount() {

        sessionStorage.setItem("isRBMRedirectfromAML", "")
        var date = new Date()
        var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1
        var date1 = date.getDate() < 10 ? "0" + (date.getDate()) : date.getDate()
        var CMLSELECTEDATE = date.getFullYear() + "-" + month + "-" + date1
        this.state.todayDate = CMLSELECTEDATE
        this.state.selectedUser = sessionStorage.getItem('username')
        this.state.selectedPass = sessionStorage.getItem('password')
        // alert(sessionStorage.getItem('IsTest'))
        this.setState({
            test: sessionStorage.getItem('IsTest'),
            selectedUser: sessionStorage.getItem('username')
        })
        if (sessionStorage.getItem('allowBatchUsersAccess') == 'true') {
            this.setState({ viewErrorpage: false })
        }
        else {
            this.setState({ viewErrorpage: true })
        }
        this.fnloadAllBactchID()
        // fntoConvertdexceldate(19985)0
        this.fnGetcompany()
    }
    fnGetcompany() {
        var data = {
            "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
            "MAPINAME": 'GETCompany',
            "MAPIPORT": '' + process.env.REACT_APP_MPORT + '',
            "body": ''
        }
        // console.log(data)
        fnGETapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'GetApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
            var data = response.data
            console.log(data)
            this.setState({
                CompanyType: data[0],
            });
            //  this.fnsetclientType(this.state.SelectedClientType)
        }).catch(e => console.log(e));
    }
    handleclose() {
        this.setState({
            showModal: false
        })
    }

    isEven(n) {
        return n % 2 == 0;
    }
    editRowdetails(editRowObj) {
        console.log("SelectedEdit", editRowObj)
        this.setState({
            showModal: true,
            selectedClientID: editRowObj['CLIENTID'],
            txtSelectedRowSurname: editRowObj['SEARCHED_SURNAME'],
            txtSelectedRowFirstname: editRowObj['SEARCHED_FIRSTNAMES'],
            ddRowGender: editRowObj['SEARCHED_GENDER'],
            txtSelectedRowDOB: this.fnToconvertinYYYYMMDD(editRowObj['SEARCHED_DOB']),
            txtSelectedRowNIC: editRowObj['SEARCHED_NIC']
        })
    }
    fnToconvertinYYYYMMDD(otherdate) {
        var year = otherdate.substring(0, 4)
        var mm = otherdate.substring(4, 6)
        var dd = otherdate.substring(6, 8)
        var fdate = year + "-" + mm + "-" + dd
        console.log("sadsad", fdate)
        return (fdate)
    }
    fnToconvertinYYYy(otherdate) {
        return (otherdate.replace("-", '').replace("-", ''))
    }
    rowEditOnUpdateClick() {
        this.state.tablebuffer.forEach(element => {
            if (element.CLIENTID == this.state.selectedClientID) {
                element.SEARCHED_SURNAME = this.state.txtSelectedRowSurname
                element.SEARCHED_FIRSTNAMES = this.state.txtSelectedRowFirstname
                element.SEARCHED_GENDER = this.state.ddRowGender
                element.SEARCHED_DOB = this.fnToconvertinYYYy(this.state.txtSelectedRowDOB)
                element.SEARCHED_NIC = this.state.txtSelectedRowNIC
                var selectedRow = element
                var data =
                {
                    "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
                    "MAPINAME": 'CheckExcelData',
                    "MAPIPORT": '' + process.env.REACT_APP_MPORT1 + '',
                    "body": {
                        "databaseDetails": {
                            "DBUserName": this.state.selectedUser,
                            "DBPassword": Fnencryption(this.state.selectedPass),
                            "DBSource": process.env.REACT_APP_ITC_DBSOURCE,
                            "DBProvider": process.env.REACT_APP_ITC_DBPROVIDER,
                            "Test": this.state.test,
                            "IsWindowsAuth": sessionStorage.getItem('IsWindowsAuth') == null ? false : sessionStorage.getItem('IsWindowsAuth')
                        },
                        selectedRow
                    }
                }
                console.log("return ", data)
                fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'PostApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
                    console.log("selectrow Responseye aarha", response.data)
                    element.SEARCHED_SURNAME = response.data.SEARCHED_SURNAME
                    element.SEARCHED_DOB = response.data.SEARCHED_DOB
                    element.SEARCHED_NIC = response.data.SEARCHED_NIC
                    element.ERROR_ROW = response.data.ERROR_ROW
                    console.log("return fro", element)
                    this.setState({
                        showModal: false
                    })
                }).catch(e => console.log(e),
                );
            }
            else {
                this.setState({
                    showModal: false
                })
            }
        });

    }
    deleteRowdetails(deleteRowObj) {
        var r = window.confirm("Are you sure you want to remove this record ?")
        if (r) {
            console.log("Before Delete :-  ", this.state.alldata)

            this.state.alldata = this.state.alldata.filter(object => {
                return object.CLIENTID !== deleteRowObj['CLIENTID'];
            })
            this.setState({ showModal: false })
            this.renderpages()
            console.log("After Delete :-  ", this.state.alldata)
        }
    }
    checkRowError(selectedRow) {

    }
    pageChange(number) {
        this.state.current = number;
        var data = this.state.alldata.slice(this.state.current * this.state.pageSize, (this.state.current + 1) * this.state.pageSize);
        this.setState({ tablebuffer: data, isTemptableBuffer: data })

        this.state.pagesObj = [];
        if (this.state.pages < 10) {
            for (var i = 0; i < this.state.pages; i++)
                this.state.pagesObj.push(i);
        }
        else {
            var min = this.state.current - 5;
            var max = this.state.current + 5;
            if (min < 0)
                min = 0;
            if (max > this.state.pages)
                max = this.state.pages;
            if (max - min > 10) {
                min = this.state.current - 5;
                max = this.state.current + 5;
            }
            if (min > 0)
                this.state.pagesObj.push(0);
            for (var i = min; i < max; i++)
                this.state.pagesObj.push(i);
            if (max < this.state.pages - 1)
                this.state.pagesObj.push(this.state.pages - 1);
        }
    }
    renderpages() {
        this.state.records = this.state.alldata.length;
        this.state.pages = parseInt(this.state.records / this.state.pageSize)
        if (this.state.records % this.state.pageSize > 0)
            this.state.pages++;
        this.state.showPager = this.state.pages > 1
        this.pageChange(0)
    }
    getCountryFromDB(COUNTRY) {

    }
    fileHandler = (event) => {
        if (this.state.SelectedCompany == "") {
            alert("Please select company")
            let randomString = Math.random().toString(36);
            this.setState({
                theInputKey: randomString
            });
        }
        else {
            let fileObj = event.target.files[0];
            //just pass the fileObj as parameter
            ExcelRenderer(fileObj, (err, resp) => {
                if (err) {
                    console.log(err);
                }
                else {
                    console.log("Checking Excel Record", resp.rows[0][0])
                    if(resp.rows[0][0]=='CLIENTID'){
                    this.setState({
                        cols: resp.cols,
                        rows: resp.rows
                    });
                    this.state.columnsrow = resp.rows.shift()
                    var pc = resp.rows
                     console.log("Pchecking Record", this.state.rows[0][0])
                    this.state.rows = pc
                    // console.log("Checking Record", this.state.rows)
                    // this.SaveFigures(false)
                    this.state.rows.forEach(element => {
                        // console.log("PC elemnet", element)
                        // console.log("PC [4]]", element[4])
                        // console.log("PC [4]]", element[4].toString().length)s
                        if (element[4] != undefined) {
                        
                        if (element[5].toString().trim() != 'U') {
                            if (element[4].toString().trim().length == 5){
                                element[4] = fntoConvertdexceldate(element[4].toString().trim())
                             }
                        }}
                        //.state.rows[this.state.rows.indexOf(element)][reDate] = this.state.rows[this.state.rows.indexOf(element)][reDate] == undefined ? "" : this.fntoConvertdate(this.state.rows[this.state.rows.indexOf(element)][reDate])
                    });
                    console.log("New Json Strings :- ", this.state.rows)
                    this.SaveFigures(false)
                    }
                    else{
                        alert("Please select a valid Batch upload file.")
                        this.setState({
                            rows:[],
                            columnsrow:[]
                        })
                     } 
                }
            });
        }
    }
    fntoConvertdate(excelDate) {
        var date = new Date(Math.round((19985 - (25569)) * 86400 * 1000));
        var converted_date = date.toISOString().split('T')[0].replace("-", "").replace("-", "");
        // console.log("converted_date ye he ", converted_date);
        return converted_date
    }
    AddBatchIDs(e) {
        if (this.state.batchId.trim() !== "") {
            var btchId = this.state.batchId.split('@')
            console.log("batchId", btchId)
            console.log("batchIdsCount", parseInt(btchId[1]))
            this.state.AllBatchIdCount = this.state.AllBatchIdCount + parseInt(btchId[1])
            this.state.AllBatchIdWidthOutComma = this.state.AllBatchIdWidthOutComma + btchId[0] + ","
            if(this.state.AllBatchIdCount>3000){
                alert("Maximum batch count allowed is 3000.");
            }
            else{
                this.setState({
                    AllBatchId: this.state.AllBatchId + this.state.batchId + ",",
                    batchId: "",
                })
            }
            // console.log("allbatchid",this.state.AllBatchIdCount)
        }
        else {
            return
        }
    }
    handleSerachChange(e, key) {
        this.setState({ key: e.target.value });
        this.state[key] = e.target.value.replace(/[^a-zA-Z-0-9\s]/g, "");
    }

    handleSomeDateChange(e) {
        if (new Date(e.target.value) > new Date()) {
            alert("DOB Can not be Greater then Today's Date")
            this.setState({ txtSelectedRowDOB: this.state.todayDate })
        }
        else {
            if (e.target.value == "")
                alert("Please select a valid date")
            else
                this.setState({ txtSelectedRowDOB: e.target.value })
        }
    }
    handlereset() {
        this.setState({
            AllBatchId: "",
            batchId: "",
            disablebutton: false,
            disablebuttoncolor: BLUE_COLOR,
            AllBatchIdCount: 0,
            AllBatchIdWidthOutComma: ''
        })
    }
    FncheckbatchExist(e) {
        var batchId = (e.target.textContent.split("@"))[0]
        var data =
        {
            "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
            "MAPINAME": 'GetBatchStatus',
            "MAPIPORT": '' + process.env.REACT_APP_MPORT1 + '',
            "body": {
                "databaseDetails": {
                    "DBUserName": this.state.selectedUser,
                    "DBPassword": Fnencryption(this.state.selectedPass),
                    "DBSource": process.env.REACT_APP_ITC_DBSOURCE,
                    "DBProvider": process.env.REACT_APP_ITC_DBPROVIDER,
                    "Test": this.state.test,
                    "IsWindowsAuth": sessionStorage.getItem('IsWindowsAuth') == null ? false : sessionStorage.getItem('IsWindowsAuth')
                },
                "batchID": batchId,
                "reprocessBatch": true
            }
        }
        console.log("ReBatch Body", data)
        fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'PostApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
            console.log("REBatchId Res", response.data[0]['VERIFICATION_STATUS'])
            if (response.data[0]['VERIFICATION_STATUS'] == 'True') { this.setState({ disablebutton: true, disablebuttoncolor: LIGHTGRAY_COLOR }) }
            else { this.setState({ disablebutton: false, disablebuttoncolor: BLUE_COLOR }) }

        }).catch(e => console.log(e),
        );
    }
    fngetcmpFullname(cmpcode) {
        if (cmpcode == "SGL")
            return "SWAN GENERAL"
        if (cmpcode == "SLL")
            return "SWAN LIFE"
        if (cmpcode == "SPL")
            return "SWAN PENSIONS"
        if (cmpcode == "SSL")
            return "SWAN SECURITIES"
        if (cmpcode == "SWL")
            return "SWAN WEALTH"
        if (cmpcode == "SSR")
            return "SWAN SSR"
    }
    formateSavejson(savejson) {
        // console.log("saving json before", savejson)
        savejson.forEach(element => {
            if(element["CLIENT_TYPE"]!=null){
            element["CLIENT_TYPE"] = element["CLIENT_TYPE"].toUpperCase()
            if (element["SEARCHED_GENDER"] == "M")
                element["SEARCHED_GENDER"] = 'MALE'
            if (element["SEARCHED_GENDER"] == "F")
                element["SEARCHED_GENDER"] = 'FEMALE'
            }
        });
        console.log("Saving ka Json : ", savejson)
        return  JSON.stringify(savejson)
    }
    saveBatchExcel() {
        if (this.state.txtBatchname.trim() != "") {
            // console.log("data in which neeed to check verify errors ,",this.state.alldata)
            var chekdata = this.state.alldata;
            chekdata.forEach(element => {
                if (element['ERROR_ROW'] != '') {
                    this.state.errormessageisenabled = true
                }
            });
            // alert(this.state.chkboxIsverify  )
            // alert(this.state.errormessageisenabled)
            // alert(this.state.errorRowColumnVisible)
            if (this.state.errorRowColumnVisible == '' && this.state.errormessageisenabled) {
                this.state.errormessageisenabled = false
                alert('Please correct all the errors before saving.')
            }
            else {
                this.setState({
                    isloading1: true,
                    showPager: false
                })
                var cmpname = this.fngetcmpFullname(this.state.SelectedCompany)
                var cmpcode = this.state.SelectedCompany
                var data =
                {
                    "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
                    "MAPINAME": 'SaveBatchData',
                    "MAPIPORT": process.env.REACT_APP_MPORT1,
                    "body": {
                        "databaseDetails": {
                            "DBUserName": sessionStorage.getItem('username'),
                            "DBPassword": Fnencryption(this.state.selectedPass),
                            "DBSource": process.env.REACT_APP_ITC_DBSOURCE,
                            "DBProvider": process.env.REACT_APP_ITC_DBPROVIDER,
                            "Test": this.state.test,
                            "IsWindowsAuth": sessionStorage.getItem('IsWindowsAuth') == null ? false : sessionStorage.getItem('IsWindowsAuth')
                        },
                        "Batch_name": this.state.txtBatchname,
                        "user_name": sessionStorage.getItem('username'),
                        "company": cmpname,
                        "compcode": cmpcode,
                        "searchType": this.state.selectedsearchtype || "",
                        "strToSave":this.formateSavejson(this.state.alldata),
                        
                    }
                }
                console.log("Save Figure new Console body", data)
                fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'PostApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
                    // console.log("Save Figure Console", response.data)
                    // console.log("response of Inpatientexcelupload", response.data)
                    alert(response.data)
                    sessionStorage.setItem("BactchidTxt", this.state.txtBatchname)
                    this.fnloadAllBactchID()
                    this.handlercancel1()
                    this.setState({
                        isloading1: false
                    })
                }).catch(e => console.log(e));
            }
        }
        else { alert("Please Enter Batch Name") }
    }
    ReprocessBatchUploading() {
        if (this.state.AllBatchId.slice(0, 1).trim() == "") {
            alert("Please Enter Atleast One Batch ID")
        }
        else {
            alert("There are " + this.state.AllBatchIdCount + " rows. It will take around " + this.state.AllBatchIdCount * 3 + " seconds to completely Reprocess batch.");
            this.getBatchUploadStatus()
            var data =
            {
                "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
                "MAPINAME": 'BatchUpload',
                "MAPIPORT": '' + process.env.REACT_APP_MPORT1 + '',
                "body": {
                    "databaseDetails": {
                        "DBUserName": this.state.selectedUser,
                        "DBPassword": Fnencryption(this.state.selectedPass),
                        "DBSource": process.env.REACT_APP_ITC_DBSOURCE,
                        "DBProvider": process.env.REACT_APP_ITC_DBPROVIDER,
                        "Test": this.state.test,
                        "IsWindowsAuth": sessionStorage.getItem('IsWindowsAuth') == null ? false : sessionStorage.getItem('IsWindowsAuth')
                    },
                    "batchID": this.state.AllBatchIdWidthOutComma,
                    "reprocessBatch": true
                }
            }
            console.log("ReBatchji Body", data)
            fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'PostApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
                this.setState({
                    displayloader: 'none', showfirstloader: false,
                    showsecondLoader: false,
                })
                console.log("REBatchId Res", response.data)
            }).catch(e => console.log(e),
            );
        }
    }
    SaveFigures(VerifyError) {
        if (this.state.txtBatchname.trim() != "") {
            var cmpname = this.fngetcmpFullname(this.state.SelectedCompany)
            var cmpcode = this.state.SelectedCompany
            this.state.isloading1 = true
            this.setState({ isloading1: true })
            var data =
            {
                "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
                "MAPINAME": 'GetValidBatchExcelData',
                "MAPIPORT": process.env.REACT_APP_MPORT1,
                "body": {
                    "databaseDetails": {
                        "DBUserName": sessionStorage.getItem('username'),
                        "DBPassword": Fnencryption(this.state.selectedPass),
                        "DBSource": process.env.REACT_APP_ITC_DBSOURCE,
                        "DBProvider": process.env.REACT_APP_ITC_DBPROVIDER,
                        "Test": this.state.test,
                        "IsWindowsAuth": sessionStorage.getItem('IsWindowsAuth') == null ? false : sessionStorage.getItem('IsWindowsAuth')
                    },
                    "Batch_name": this.state.txtBatchname,
                    "user_name": sessionStorage.getItem('username'),
                    "company": cmpname,
                    "compcode": cmpcode,
                    "searchType": this.state.selectedsearchtype || "",
                    "columnnames": this.state.columnsrow,
                    "columnvalues": this.state.rows,
                    "VerifyError": VerifyError
                }
            }
            fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'PostApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
                console.log("Save Figure Console Data", response.data)
                if (!response.data) {
                    alert("Excel is incorrect format for upload. Sheet must contain header columns as specified. ")
                    this.setState({ isloading1: false })
                }
                else {
                    this.setState({ alldata: response.data })
                    this.renderpages()
                    this.setState({ isloading1: false })
                }
                // console.log("response of Inpatientexcelupload", response.data)           
                // alert(response.data)
                // this.fnloadAllBactchID()
                // this.handlercancel()
            }).catch(e => console.log(e));
        }
        else { alert("Please Enter Batch Name") }
    }
    getBatchUploadStatus() {
        try {
            this.setState({
                showfirstloader: true,
                showsecondLoader: false
            })
            var dataloader =
            {
                "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
                "MAPINAME": 'GetBatchUploadStatus',
                "MAPIPORT": '' + process.env.REACT_APP_MPORT1 + '',
                "body": {
                    "databaseDetails": {
                        "DBUserName": this.state.selectedUser,
                        "DBPassword": Fnencryption(this.state.selectedPass),
                        "DBSource": process.env.REACT_APP_ITC_DBSOURCE,
                        "DBProvider": process.env.REACT_APP_ITC_DBPROVIDER,
                        "Test": this.state.test,
                        "IsWindowsAuth": sessionStorage.getItem('IsWindowsAuth') == null ? false : sessionStorage.getItem('IsWindowsAuth')
                    },
                    "batchID": this.state.AllBatchId.split("@")[0],
                }
            }
            console.log("LoaderPercenddtage Body", dataloader)
            this.setState({
                displayloader: 'none', showfirstloader: false,
                showsecondLoader: true,
            })
            setInterval(async () => {
                fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'PostApiMiddleWare', dataloader, process.env.REACT_APP_PORT_MIDDLEWARE).then((response1) => {
                    //  console.log("Return Percentage pahleis ", response1.data)
                    //console.log("Return Percdddentage pahleis ", response1.data[0]['PER'])
                    // alert(response1.data[0]['PER'])
                    // if(response1.data[0]['PER']!= undefined){

                    if (response1.data[0]['PER'] == 100 || response1.data[0]['PER'] >= 100) {
                        this.setState({
                            isloading: "none",
                            showModal: false,
                            AllBatchId: "",
                            showfirstloader: false,
                            showsecondLoader: false,
                            batchId: "",
                            // modalmessage: response1.data,
                            AllBatchIdCount: 0,
                            AllBatchIdWidthOutComma: ''
                        })
                        alert('Batch is Completed')
                        window.location.reload(false);
                        // this.fnloadAllBactchID()
                        clearInterval(1000)
                    }
                    else {
                        this.setState({ runbatchIdvalue: response1.data[0]['PER'] })
                        console.log(this.state.runbatchIdvalue)
                    }
                }).catch(e => console.log(e))
            }, 5000);
        } catch (e) {
            console.log(e);
        }
    }
    BatchUploading(e) {
        if (this.state.AllBatchId.slice(0, 1).trim() == "") {
            alert("Please Enter Atleast One Batch ID")
        }
        else {

            // var batchID = (this.state.AllBatchId.split("@"))[0]
            // var batchCount = (this.state.AllBatchId.split("@"))[1].slice(0, -1)
            alert("There are " + this.state.AllBatchIdCount + " rows. It will take around " + this.state.AllBatchIdCount * 3 + " seconds to completely upload batch.");
            // this.setState({ displayloader: '' })
            this.getBatchUploadStatus()
            var data =
            {
                "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
                "MAPINAME": 'BatchUpload',
                "MAPIPORT": '' + process.env.REACT_APP_MPORT1 + '',
                "body": {
                    "databaseDetails": {
                        "DBUserName": this.state.selectedUser,
                        "DBPassword": Fnencryption(this.state.selectedPass),
                        "DBSource": process.env.REACT_APP_ITC_DBSOURCE,
                        "DBProvider": process.env.REACT_APP_ITC_DBPROVIDER,
                        "Test": this.state.test,
                        "IsWindowsAuth": sessionStorage.getItem('IsWindowsAuth') == null ? false : sessionStorage.getItem('IsWindowsAuth')
                    },
                    "batchID": this.state.AllBatchIdWidthOutComma,
                    "reprocessBatch": false
                }
            }
            console.log("Batch Body", data)
            fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'PostApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
                // console.log("BatchId Response",response)
                // console.log("BatchId Res",response.data)
                // this.searchandsave(data, response.data.SearchResultMSG.length,response1.data.SearchResultMSG.length)
                this.setState({
                    displayloader: 'none', showfirstloader: false,
                    showsecondLoader: true,
                })


            }).catch(e => console.log(e),
            );
        }
    }
    handleLogout() {
        this.setState({
            redirect: true,
            direction: "/AML"
        })
    }
    fnloadAllBactchID() {
        var data =
        {
            "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
            "MAPINAME": 'GetAMLBatches',
            "MAPIPORT": process.env.REACT_APP_MPORT1,
            "body": {
                "databaseDetails": {
                    "DBUserName": sessionStorage.getItem('username'),
                    "DBPassword": Fnencryption(this.state.selectedPass),
                    "DBSource": process.env.REACT_APP_ITC_DBSOURCE,
                    "DBProvider": process.env.REACT_APP_ITC_DBPROVIDER,
                    "Test": sessionStorage.getItem('IsTest'),
                    "IsWindowsAuth": sessionStorage.getItem('IsWindowsAuth') == null ? false : sessionStorage.getItem('IsWindowsAuth')
                }
            }
        }
        fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'postApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
            var rowObj = response.data
            console.log("AllBatchID's", rowObj)
            var batchs_array = []
            {
                for (var i of rowObj) {
                    batchs_array.push(i.BATCHID.toString() + "@" + i.BATCHCOUNT.toString());
                }
            }
            // console.log("Selected", batchs_array)
            var findingarrayvalue = batchs_array.find(element => element.includes(sessionStorage.getItem("BactchidTxt")));
            // console.log("Value display selectedShoud be",findingarrayvalue)
            this.setState({
                batchesarray: rowObj, SearchOptions: batchs_array, batchId: findingarrayvalue
            })
        }).catch(e => console.log(e));
    }
    fntosetBatchId(companyname) {
        var data =
        {
            "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
            "MAPINAME": 'GenrateNewBatchID',
            "MAPIPORT": process.env.REACT_APP_MPORT1,
            "body": {
                "databaseDetails": {
                    "DBUserName": sessionStorage.getItem('username'),
                    "DBPassword": Fnencryption(this.state.selectedPass),
                    "DBSource": process.env.REACT_APP_ITC_DBSOURCE,
                    "DBProvider": process.env.REACT_APP_ITC_DBPROVIDER,
                    "Test": sessionStorage.getItem('IsTest'),
                    "IsWindowsAuth": sessionStorage.getItem('IsWindowsAuth') == null ? false : sessionStorage.getItem('IsWindowsAuth')
                },
                "company": companyname
            }
        }
        console.log("result", data)
        fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'postApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
            var rowObj = response.data
            console.log("New Genrated BatchId", rowObj)
            this.setState({ txtBatchname: rowObj })
        }).catch(e => console.log(e));
    }
    SaveandGenrateExcel() {
        var d = JSON.stringify(this.state.isTemptableBuffer) === JSON.stringify(this.state.tablebuffer)
        if (d) {
        } else { }
    }
    handleExporttoExcel() {
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';
        const ws = XLSX.utils.json_to_sheet(this.state.alldata);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, "Batchuploadfile" + fileExtension);
    }
    onchkBoxVerifytick() {
        this.setState({
            isChecked: !this.state.isChecked,
            errorRowColumnVisible: this.state.isChecked ? 'none' : '',
            isloading1: false
        })
        this.SaveFigures(true)
    }
    handlercancel1() {
        //     var r = window.confirm("Do you really want Cancel ?")
        // if (r == true)
        //   window.location.reload();
        let randomString = Math.random().toString(36);

        this.setState({
            theInputKey: randomString
        });
        this.setState({
            txtBatchname: "",
            SelectedCompany: "",
            tablebuffer: [],
            isloading1: false
        })

    }
    handlercancel() {
        var r = window.confirm("Do you really want Clear/Cancel ?")
        if (r == true) {
            let randomString = Math.random().toString(36);
            window.location.reload(true)
            // this.setState({
            //     theInputKey: randomString
            // });
            // this.state.chkboxIsverify=false
            // this.setState({
            //     txtBatchname: "",
            //     SelectedCompany: "",
            //     tablebuffer: [],
            //     isloading1: false,
            //     chkboxIsverify:false,showPager:false
            // })
        }
    }
    render() {

        return (

            <Fragment>
                {this.state.redirect &&
                    <Redirect to={this.state.direction} />
                }
                {!this.state.viewErrorpage ?
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        style={{ marginTop: 35 }}
                    >
                        <Navigationmenu selectedMenu={'BATCHPAGE'} />

                        <Paper elevation={2} style={{ minHeight: 100, width: '90%', borderRadius: 6 }}>
                            <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                            >
                                <div style={{ minHeight: 100, width: '98%', borderRadius: 6 }}>
                                    <Grid container spacing={2} >
                                        <Grid item xs={11}>
                                            <div style={{
                                                display: 'flex',
                                                marginBottom: 20,
                                                marginTop: 60
                                            }}>
                                                <Typography style={{ borderWidth: 0, color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', fontSize: 30, paddingLeft: 10 }}>Batch File Upload</Typography>
                                            </div>
                                        </Grid>
                                        <Grid item xs={1}>
                                            <Box
                                                display="flex"
                                                alignItems="center"
                                                justifyContent="center"
                                            >
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <div>
                                        <Accordion>
                                            <AccordionSummary
                                                expandIcon={<ArrowDropDown />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                            >
                                                <Typography style={{ borderWidth: 0, color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', fontSize: 18, paddingLeft: 10 }}>Upload Excel File</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <Grid container spacing={3}>
                                                    <Grid item xs={2}>
                                                        <Typography style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', fontSize: 13, paddingLeft: 10 }}>
                                                            Company</Typography>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <Select
                                                            style={{ width: '197px', height: '32px' }}
                                                            variant={'outlined'}
                                                            value={this.state.SelectedCompany}
                                                            onChange={e => this.setState({ SelectedCompany: e.target.value }, this.fntosetBatchId(e.target.value)
                                                            )}
                                                        >
                                                            {
                                                                this.state.CompanyType.map(team => (
                                                                    <MenuItem value={team.COMPCODE}>{team.COMPANY}</MenuItem>
                                                                ))
                                                            }
                                                        </Select>
                                                    </Grid>
                                                    <Grid item xs={8}>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <Typography style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', fontSize: 13, paddingLeft: 10 }}>
                                                            Batch Id</Typography>
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <TextField disabled
                                                            value={this.state.txtBatchname}
                                                            variant='outlined'
                                                            onChange={(e) => this.handleSerachChange(e, "txtBatchname")}
                                                            InputProps={{ style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK, height: '30px', marginLeft: '0px' } }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={4}></Grid>
                                                    <Grid item xs={2}>
                                                        <Typography style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', fontSize: 13, paddingLeft: 10 }}>
                                                            Search Type</Typography>
                                                    </Grid>

                                                    <Grid item xs={6}>
                                                        <Select
                                                            style={{ width: '197px', height: '32px' }}
                                                            variant={'outlined'}
                                                            value={this.state.selectedsearchtype}
                                                            onChange={e => this.setState({ selectedsearchtype: e.target.value }
                                                            )}
                                                        >
                                                            <MenuItem value={'FULL-ONGOING'}>FULL-ONGOING</MenuItem>
                                                            <MenuItem value={'FULL-ONETIME'}>FULL-ONETIME</MenuItem>
                                                        </Select>
                                                    </Grid>
                                                    <Grid item xs={4}></Grid>
                                                    <Grid item xs={2}>
                                                        <Typography style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', fontSize: 13, paddingLeft: 10 }}>
                                                            Path for the excel</Typography>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <input type="file" key={this.state.theInputKey || ''} onChange={this.fileHandler.bind(this)} style={{ width: '100%' }} />
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <Checkbox name="chkdoNotShare" onChange={(e) => this.onchkBoxVerifytick()} color="primary" value={this.state.chkboxIsverify} />
                                                        <span style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', fontSize: 13 }}>Verify Error</span>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <Button variant={'text'} onClick={(e) => this.saveBatchExcel()} style={{ color: 'white', fontFamily: 'Globerbold', marginLeft: "-140px", backgroundColor: BLUE_COLOR, marginTop: "1px", width: '120px', height: "40px", fontSize: 14 }}>
                                                            Save
                                                        </Button>
                                                        <Button variant={'text'} onClick={(e) => this.handlercancel()} style={{ color: 'white', fontFamily: 'Globerbold', marginLeft: "2px", backgroundColor: VIBRANT_GREEN, marginTop: "1px", width: '122px', height: "40px", fontSize: 14 }}>
                                                            CLEAR / CANCEL
                                                        </Button>
                                                        <Button variant={'text'} onClick={(e) => this.handleExporttoExcel()} style={{ color: 'white', fontFamily: 'Globerbold', marginLeft: "2px", backgroundColor: VIBRANT_GREEN, marginTop: "1px", width: '120px', height: "40px", fontSize: 14 }}>
                                                            Export
                                                        </Button>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <img style={{ width: "100px", display: this.state.displayloader }} src={circulargridimage} alt="circulargridimage" />
                                                    </Grid>
                                                    <TableContainer>
                                                        <Table aria-label="table">
                                                            <TableHead style={{ backgroundColor: 'rgba(241,241,241,1.0)' }}>
                                                                <TableRow>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', width: "150px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">CLIENTID</TableCell>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', width: "120px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">CLIENT_TYPE</TableCell>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">SEARCHED_SURNAME</TableCell>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">SEARCHED_FIRSTNAMES</TableCell>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">SEARCHED_DOB</TableCell>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">SEARCHED_GENDER</TableCell>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', width: "190px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">SEARCHED_NIC</TableCell>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', width: "190px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">NATIONALITY_CD</TableCell>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', width: "190px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.errorRowColumnVisible }} align="center">Error</TableCell>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', width: "50px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold,', display: this.state.errorRowColumnVisible }} align="center"></TableCell>
                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', width: "50px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.errorRowColumnVisible }} align="center"></TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {!this.state.isloading1 ?
                                                                    this.state.tablebuffer.map((obj, index) => {
                                                                        var rowbackgroundColor = 'white';
                                                                        if (this.isEven(index)) { rowbackgroundColor = ALTERNATEROW_BACKGROUND_COLOR; }

                                                                        if (this.state.ishovered && this.state.hoverindex == index) { rowbackgroundColor = LIGHTGRAY_COLOR }
                                                                        if (obj != undefined) {
                                                                            return (
                                                                                <TableRow style={{ cursor: 'pointer' }} key={index} >
                                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, }} align="center">{obj.CLIENTID}</TableCell>
                                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, }} align="center">{obj.CLIENT_TYPE}</TableCell>
                                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, }} align="center">{obj.SEARCHED_SURNAME}</TableCell>
                                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, }} align="center">{obj.SEARCHED_FIRSTNAMES}</TableCell>
                                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, }} align="center">{obj.SEARCHED_DOB}</TableCell>
                                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, }} align="center">{obj.SEARCHED_GENDER}</TableCell>
                                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, }} align="center">{obj.SEARCHED_NIC}</TableCell>
                                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, }} align="center">{obj.NATIONALITY_CD}</TableCell>
                                                                                    <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, color: RED_COLOR, display: this.state.errorRowColumnVisible }} align="center">{obj.ERROR_ROW}</TableCell>
                                                                                    <TableCell style={{ borderWidth: 0, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.errorRowColumnVisible }} align="center"><Typography style={{ textTransform: 'uppercase', fontSize: '14px', fontFamily: 'Globerbold' }} onClick={(e) => this.editRowdetails(obj)}> <Edit style={{ height: 25, width: 32, color: BLUE_COLOR, marginLeft: 5, marginTop: 5 }} /></Typography></TableCell>
                                                                                    <TableCell style={{ borderWidth: 0, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.errorRowColumnVisible }} align="center"><Typography style={{ textTransform: 'uppercase', fontSize: '14px', fontFamily: 'Globerbold' }} onClick={(e) => this.deleteRowdetails(obj)}> <Delete style={{ height: 25, color: RED_COLOR, width: 32, marginLeft: 5, marginTop: 5 }} /></Typography></TableCell>

                                                                                </TableRow>
                                                                            )
                                                                        }
                                                                    })
                                                                    : <td style={{ marginLeft: "500px", height: "100px" }}>
                                                                        {/* Loading.... <CircularProgress classes="CircularProgress" /> */}
                                                                        <img style={{ width: "100px" }} src={circulargridimage} alt="circulargridimage" />;
                                                                    </td>}
                                                            </TableBody>
                                                        </Table>
                                                        <div style={this.state.showPager ? { height: 60, marginLeft: "500px", color: MODIFIEDBLACK, fontSize: "15px", textTransform: 'uppercase', fontFamily: 'Globerbold', wordBreak: "break-word" } : { display: "none" }} >
                                                            {
                                                                this.state.pagesObj.map((obj, index) => {
                                                                    return (
                                                                        <span style={{ padding: "0 3px", cursor: "pointer" }}>
                                                                            <a style={this.state.current == obj ? { fontWeight: 'bold', color: BLUE_COLOR, fontSize: "30px" } : {}} onClick={() => this.pageChange(obj)} >{obj + 1}</a>
                                                                        </span>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    </TableContainer>
                                                </Grid>
                                            </AccordionDetails>
                                        </Accordion>
                                        <Accordion>
                                            <AccordionSummary
                                                expandIcon={<ArrowDropDown />}
                                                aria-controls="panel2a-content"
                                                id="panel2a-header"
                                            >
                                                <Typography style={{ borderWidth: 0, color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', fontSize: 18, paddingLeft: 10 }}>Post Batches To Refinitiv</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <Grid container spacing={3}>

                                                    {/* <Grid item xs={2}>
                                                        <Select
                                                            labelId="demo-simple-select-helper-label"
                                                            id="demo-simple-select-helper"
                                                            style={{ width: '197px', height: '32px' }}
                                                            variant="outlined"
                                                            value={this.state.batchId}
                                                            onChange={e => this.setState({ batchId: e.target.value },
                                                                this.FncheckbatchExist(e))}>
                                                            {this.state.batchesarray.map(team => (
                                                                <MenuItem value={team.BATCHID}>{team.BATCHID}</MenuItem>
                                                            ))}
                                                        </Select>
                                                    </Grid> */}
                                                    <Grid item xs={3}>
                                                        <Autocomplete
                                                            id="combo-box-demo" value={this.state.batchId}
                                                            onChange={e => this.setState({ batchId: e.target.textContent },
                                                                this.FncheckbatchExist(e), console.log(e))}
                                                            options={this.state.SearchOptions}
                                                            // getOptionLabel={(option) =>option.BATCHID || ""}
                                                            //     renderOption={(props, option) => (
                                                            //         <li style={{color:option.BATCHCOLOR}}>
                                                            //           {option.BATCHID }
                                                            //         </li>
                                                            //       )}
                                                            renderInput={(params) => <TextField {...params} label="Select BatchId" />}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <Button variant={'text'} onClick={(e) => this.AddBatchIDs("QUICK")} style={{ color: 'white', fontFamily: 'Globerbold', backgroundColor: VIBRANT_GREEN, marginLeft: '30px', height: '40px', fontSize: 14 }}>
                                                            Add Batch Id
                                                        </Button>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <TextField
                                                            fullWidth label="Batch Id's" value={this.state.AllBatchId}
                                                            onChange={(e) => this.handleSerachChange(e, "AllBatchId")}
                                                            variant="outlined"
                                                            multiline
                                                            disabled
                                                            rows={5}
                                                            InputLabelProps={{ style: { fontFamily: 'Globerbold', color: BLUE_COLOR } }} />

                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <Button variant={'text'} onClick={(e) => this.handlereset(e)} style={{ color: 'white', fontFamily: 'Globerbold', marginLeft: "2px", backgroundColor: VIBRANT_GREEN, marginLeft: "-15px", marginTop: "1px", width: '150px', height: "40px", fontSize: 14 }}>
                                                            Clear BatchIds
                                                        </Button>
                                                        <br></br>
                                                        <Button variant={'text'} onClick={(e) => this.BatchUploading(e)} disabled={this.state.disablebutton} style={{ color: 'white', fontFamily: 'Globerbold', marginLeft: "2px", backgroundColor: this.state.disablebuttoncolor, marginLeft: "-15px", marginTop: "1px", width: '150px', height: "40px", fontSize: 14 }}>
                                                            Run BatchIds
                                                        </Button>
                                                        <br></br>
                                                        <Button variant={'text'} onClick={(e) => this.ReprocessBatchUploading(e)} style={{ color: 'white', fontFamily: 'Globerbold', marginLeft: "2px", backgroundColor: BLUE_COLOR, marginLeft: "-15px", marginTop: "1px", width: '150px', height: "40px", fontSize: 14 }}>
                                                            Reprocess failed Batchs
                                                        </Button>
                                                    </Grid>
                                                    <Grid item xs={5}></Grid>
                                                    <Grid item xs={7}>
                                                        {this.state.showfirstloader ? <div>
                                                            <div><CircularProgress style={{ marginLeft: '85px' }}></CircularProgress></div>
                                                            <div>Please wait for a while we are fetching process %</div>
                                                        </div> : ''}
                                                        {this.state.showsecondLoader ?
                                                            <CircularProgressWithLabel
                                                                loadpercentage={this.state.runbatchIdvalue}
                                                                loadBatchId={this.state.AllBatchId}
                                                                loaduserName={this.state.selectedUser}
                                                                loadPassword={Fnencryption(this.state.selectedPass)}
                                                                loadstest={this.state.test}></CircularProgressWithLabel>
                                                            : ''} </Grid>
                                                </Grid>
                                            </AccordionDetails>
                                        </Accordion>
                                    </div>
                                    <div style={{ height: 10 }} />
                                    <Divider></Divider>
                                    <img style={{ width: "100px", marginLeft: "500px", display: this.state.isloading }} src={circulargridimage} alt="circulargridimage" />
                                    <br></br>
                                    Disclaimer: You are kindly advised that we will retain audit trails of searches made on the AML Watchlist for monitoring purposes.
                                    <br></br>
                                    {/* <Footer></Footer> */}
                                    <br></br>
                                    <Dialog fullWidth open={this.state.showModal} onClose={e => this.handleclose()} aria-labelledby="form-dialog-title">
                                        <DialogTitle id="form-dialog-title">Edit Selected Row</DialogTitle>
                                        <Divider variant="middle" />
                                        <DialogContent>
                                            <Grid container spacing={3}>
                                                <Grid item xs={3}>
                                                    <Typography style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', fontSize: 13, paddingLeft: 10 }}>
                                                        CLIENTID</Typography>
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <Typography style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', fontSize: 13, paddingLeft: 10 }}>
                                                        {this.state.selectedClientID}</Typography>
                                                </Grid>
                                                <Grid item xs={7}>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <Typography style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', fontSize: 13, paddingLeft: 10 }}>
                                                        SURNAME/COMPANY NAME</Typography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        value={this.state.txtSelectedRowSurname}
                                                        variant='outlined'
                                                        onChange={(e) => this.handleSerachChange(e, "txtSelectedRowSurname")}
                                                        inputProps={{ maxLength: 30, style: { fontFamily: 'Globerbold', height: '0px', color: MODIFIEDBLACK, marginLeft: '0px' } }}
                                                    />
                                                </Grid>
                                                <Grid item xs={3}></Grid>
                                                <Grid item xs={3}>
                                                    <Typography style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', fontSize: 13, paddingLeft: 10 }}>
                                                        FIRSTNAME</Typography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        value={this.state.txtSelectedRowFirstname}
                                                        variant='outlined'
                                                        onChange={(e) => this.handleSerachChange(e, "txtSelectedRowFirstname")}
                                                        inputProps={{ maxLength: 30, style: { fontFamily: 'Globerbold', height: '0px', color: MODIFIEDBLACK, marginLeft: '0px' } }}
                                                    />
                                                </Grid>
                                                <Grid item xs={3}></Grid>
                                                <Grid item xs={3}>
                                                    <Typography style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', fontSize: 13, paddingLeft: 10 }}>
                                                        GENDER</Typography>
                                                </Grid>
                                                <Grid item xs={6}>

                                                    <Select
                                                        style={{ height: 33, color: MODIFIEDBLACK, fontFamily: 'Globerbold', fontSize: 13 }}
                                                        variant={'outlined'}
                                                        value={this.state.ddRowGender}
                                                        onChange={e => this.setState({ ddRowGender: e.target.value })}>
                                                        <MenuItem value="U"></MenuItem>
                                                        <MenuItem value={'F'}>FEMALE</MenuItem>
                                                        <MenuItem value={'M'}>MALE</MenuItem>
                                                    </Select>
                                                </Grid>
                                                <Grid item xs={3}></Grid>
                                                <Grid item xs={3}>
                                                    <Typography style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', fontSize: 13, paddingLeft: 10 }}>
                                                        DOB </Typography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        value={this.state.txtSelectedRowDOB}
                                                        variant='outlined'
                                                        type="date"
                                                        onChange={(e) => this.handleSomeDateChange(e)}
                                                        inputProps={{
                                                            max: "" + this.state.todayDate + "",
                                                            style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK, height: '0px', marginLeft: '0px' }
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={2}></Grid>
                                                <Grid item xs={1}></Grid>
                                                <Grid item xs={3}>
                                                    <Typography style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', fontSize: 13, paddingLeft: 10 }}>
                                                        NIC </Typography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        value={this.state.txtSelectedRowNIC}
                                                        variant='outlined'
                                                        onChange={(e) => this.handleSerachChange(e, "txtSelectedRowNIC")}
                                                        inputProps={{ maxLength: 18, style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK, height: '0px', marginLeft: '0px' } }}
                                                    />
                                                </Grid>
                                                <Grid item xs={3}></Grid>
                                                <Grid item xs={5}>
                                                </Grid>
                                                <Grid item xs={5}>
                                                    <Button variant={'text'} onClick={(e) => this.rowEditOnUpdateClick()} style={{ color: 'white', fontFamily: 'Globerbold', marginLeft: "-180px", backgroundColor: BLUE_COLOR, width: '120px', height: '40px', fontSize: 14, paddingLeft: 10 }}>
                                                        Update</Button>
                                                    <Button variant={'text'} onClick={() => this.setState({ showModal: false })} style={{ color: 'white', fontFamily: 'Globerbold', marginLeft: "2px", backgroundColor: VIBRANT_GREEN, marginTop: "1px", width: '120px', height: "40px", fontSize: 14 }}>
                                                        Cancel
                                                    </Button>
                                                </Grid>

                                            </Grid>
                                        </DialogContent>
                                        <DialogActions>
                                            <Button onClick={() => this.setState({ showModal: false })} color="primary">
                                                Close
                                            </Button>
                                        </DialogActions>
                                    </Dialog>


                                </div>
                            </Box>
                        </Paper>
                    </Box >
                    :
                    <Page404
                        h3text='Sorry, You have no Access for this page !!'
                        txtsecondary='Please Ask To Admin For Further details !'
                        bgcolor='goldenrod'
                    ></Page404>
                }
            </Fragment>
        )
    }
}